// export const DEFAULT_RELAY_URL = "wss://relay.walletconnect.com";
export const DEFAULT_RELAY_URL = "wss://walletconnect.provable.dev";
export const WC_PROJECT_ID = "4c84a16b48471ad04556004e104779b5";
